import * as React from 'react'
import {Layout} from '../../atoms/Layout'
import styled from 'styled-components'
import {Nav} from '../../atoms/Nav'
import {ProfileDropdown} from '../../organisms/ProfileDropdown'
import downArrow from '../../atoms/Down-arrow/down-arrow.svg'
import {Content} from '../../atoms/Content/index'
import {media} from '../../utils/media'
import {HcpWelcomeFormContainer} from '../../organisms/HCP_Welcome/HCP_WelcomeFormContainer'
import {P} from '../../atoms/P'

export const HcpWelcome = () => (
  <Layout>
    <Nav.BarTips>
      <Nav.HomeButtonTips showHamburger={false}/>
      <Nav.Button>Form</Nav.Button>
      <Nav.Button>Info</Nav.Button>
      <Nav.Button>Help</Nav.Button>
      <Nav.Button>Print</Nav.Button>
      <Nav.Button>About</Nav.Button>
      <ProfileDropdown color={null}/>
    </Nav.BarTips>
    <span className="d-none d-sm-block">
      <Header>
        <img style={{width: '100%'}}
             src="https://s3-us-west-1.amazonaws.com/uci-images/images/hcp-welcome-header.jpg"/>
        <HeaderTitle>Healthcare Providers</HeaderTitle>
        <HeaderText>
          This site will present new research findings that show how to adjust behaviors
          that you already use to effectively reduce children’s preoperative distress.</HeaderText>
      </Header>
    </span>
    <span className="d-block d-sm-none">
      <Header>
        <img style={{width: '100%'}}
             src="https://s3-us-west-1.amazonaws.com/uci-images/images/hcp-welcome-header-m.jpg"/>
        <HeaderTitle>Healthcare Providers</HeaderTitle>
      </Header>
    </span>
    <Content>
      <SMtext>
        This site will present new research findings that show how to adjust behaviors
        that you already use to effectively reduce children’s preoperative distress.</SMtext>
      <P style={{fontSize: 20}}>Children that completed this program that was developed
        by Dr. Zeev Kain were, on average, just as calm as children who received a sedative before surgery.</P>
      <HcpWelcomeFormContainer/>
    </Content>
  </Layout>
)

const Header = styled.header`
  width: 100%;
  position: relative;
`

const HeaderTitle = styled.div`
  display: flex;
  justify-content: center;
  margin-top: -130px;
  margin-left: auto;
  margin-right: auto;
  left: 40px;
  right: 40px;
  max-width: 1000px;
  width: auto;
  bottom: 40px;
  font-size: 2rem;
  color: white;

  ${media.desktop`
  margin-top: -160px;
  font-size: 3rem;
  `}

  @media (max-width: 575px) {
    margin-top: -65px;
  }
`

const HeaderText = styled.div`
  display: flex;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
  left: 40px;
  right: 40px;
  max-width: 1000px;
  width: auto;
  bottom: 40px;
  text-align: center
  font-size: 1.2rem;
  color: white;

  ${media.desktop`
    font-size: 1.5rem;
  `}
`

const SMtext = styled.p`
  display: none;
  @media (max-width: 575px) {
    margin-top: 15px;
    display: -webkit-box;
    font-family: "SF Pro Display";
    font-size: 20px;
    color: #172129;
    line-height: 24px;
    margin: 14px 0;
  }
`



// WEBPACK FOOTER //
// ./src/pages/HCP_Welcome/index.tsx